var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-subheader',{staticClass:"primary--text font-weight-medium px-0"},[_vm._t("default")],2),_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }